import React, { useState, Fragment } from "react";
import { useStyles } from "./styles";
import DashboardIcon from "@material-ui/icons/Dashboard";
import {
  Typography,
  IconButton,
  Card,
  CardContent,
  Popover,
  Grid,
} from "@material-ui/core";

export default function Produtos() {
  const [anchorEl, setAnchorEl] = useState(null);
  const classes = useStyles();

  function openLink(link) {
    window.open(link, "_self");
  }

  return (
    <Fragment>
      <IconButton
        aria-controls="atendimento"
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <DashboardIcon className={classes.produtos} />
      </IconButton>
      <Popover
        id="usuario"
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Card>
          <CardContent>
            <div className={classes.tituloProdutos}>
              <Typography className={classes.titloCard}>Produtos</Typography>
            </div>

            <div className={classes.actions}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <div className={classes.produtoItem}>
                    <div
                      onClick={() =>
                        openLink("https://eauditor.e-auditoria.com.br/")
                      }
                    >
                      <img src={"https://images.e-auditoria.com.br/global/logos/svg/eauditor-mini-white.svg"} alt="eAuditor" width="100px" />
                      <p className={classes.produtoItemParagrafo}>e-Auditor</p>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div className={classes.produtoItem}>
                    <div
                      onClick={() =>
                        openLink("https://esimulador.e-auditoria.com.br/")
                      }
                    >
                      <img src={"https://images.e-auditoria.com.br/global/logos/svg/esimulador-mini-white.svg"} alt="eSimulador" width="100px" />
                      <p className={classes.produtoItemParagrafo}>
                        e-Simulador
                      </p>
                    </div>
                  </div>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <div className={classes.produtoItem}>
                    <div
                      onClick={() =>
                        openLink("https://econsulta.e-auditoria.com.br/")
                      }
                    >
                      <img src={"https://images.e-auditoria.com.br/global/logos/svg/econsulta-mini-white.svg"} alt="eConsulta" width="100px" />
                      <p className={classes.produtoItemParagrafo}>e-Consulta</p>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div className={classes.produtoItem}>
                    <div
                      onClick={() =>
                        openLink("https://edrive.e-auditoria.com.br/")
                      }
                    >
                      <img src={"https://images.e-auditoria.com.br/global/logos/svg/edrive-mini-white.svg"} alt="eDrive" width="100px" />
                      <p className={classes.produtoItemParagrafo}>e-Drive</p>
                    </div>
                  </div>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <div className={classes.produtoItem}>
                    <div
                      onClick={() =>
                        openLink("https://conta.e-auditoria.com.br/eCapturador")
                      }
                    >
                      <img src={"https://images.e-auditoria.com.br/global/logos/svg/ecapturador-mini-white.svg"} alt="eCapturador" width="100px" />
                      <p className={classes.produtoItemParagrafo}>
                        e-Capturador
                      </p>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div className={classes.produtoItem}>
                    <div
                      onClick={() =>
                        openLink(
                          "https://conta.e-auditoria.com.br/eAtendimento"
                        )
                      }
                    >
                      <img src={"https://images.e-auditoria.com.br/global/logos/svg/eatendimento-mini-white.svg"} alt="eAtendimento" width="100px" />
                      <p className={classes.produtoItemParagrafo}>
                        e-Atendimento
                      </p>
                    </div>
                  </div>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <div className={classes.produtoItem}>
                    <div
                      onClick={() =>
                        openLink("https://erecuperador.e-auditoria.com.br/")
                      }
                    >
                      <img src={"https://images.e-auditoria.com.br/global/logos/png/erecuperador-mini-white.png"} alt="eRecuperador" width="100px" />
                      <p className={classes.produtoItemParagrafo}>
                        e-Recuperador
                      </p>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div className={classes.produtoItem}>
                    <div
                      onClick={() =>
                        openLink("https://emonitor.e-auditoria.com.br/")
                      }
                    >
                      <img src={"https://images.e-auditoria.com.br/global/logos/svg/emonitor-mini-white.svg"} alt="eMonitor" width="100px" />
                      <p className={classes.produtoItemParagrafo}>e-Monitor</p>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </div>
          </CardContent>
        </Card>
      </Popover>
    </Fragment>
  );
}
